import { http } from 'services/http';
import { WAREHOUSE_TASK_GET_ONE } from 'api/query-keys.ts';
import type { TWarehouseTaskUpdateReq, TWarehouseTaskRes } from 'api/swagger';
import { useMutationBase } from 'shared/hooks/use-mutation-base.ts';

export const useUpdateWarehouseTask = (whTaskId: number) => {
  return useMutationBase<TWarehouseTaskRes, unknown, TWarehouseTaskUpdateReq>({
    mutationFn: async (variables) => {
      const res = await http.patch<TWarehouseTaskRes>(`/v1/warehouse-tasks/${whTaskId}`, variables);

      return res.data;
    },
    invalidateCallback: () => [[WAREHOUSE_TASK_GET_ONE, whTaskId]],
  });
};
